import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
import Select from "react-select";

import { Code } from '@mui/icons-material';
import EntityTab from './Tabs/EntityTab';
import ShippingDtlsTab from './Tabs/ShippingDtlsTab';
import RoutingTab from './Tabs/RoutingTab';
import AttachedHouseTab from './Tabs/AttachedHouseTab';
import ItemsTabs from './Tabs/ItemsTabs';
import PickupTab from './Tabs/PickupTab';
import AWBinfoTab from './Tabs/AWBinfoTab';
import ChargesTabs from './Tabs/ChargesTabs';
import FinancialsTab from './Tabs/FinancialsTab';
import GoodsDetailsTab from './Tabs/GoodsDetailsTab';
import EdocketTab from './Tabs/EdocketTab';
import TrackingTab from './Tabs/TrackingTab';
import ActivityTab from './Tabs/ActivityTab';
import NotesTab from './Tabs/NotesTab';
import HistoryTab from './Tabs/HistoryTab';
import ContainerTab from './Tabs/ContainerTab';
// import ReactTooltip from 'react-tooltip';
// import GeneralTab from './General/GeneralTab';
// import ShipperTab from './General/ShipperTab';
// import Consignee from './General/Consignee';
// import ServicesTab from './General/ServicesTab';
// import AccountInfo from './General/AccountInfo';
// import ServiceTab from './General/ServiceTab';
// import EntityTab from './General/EntityTab';
// import FreightTab from './General/FreightTab';
// import CustomsTab from './General/CustomsTab';
// import TransportTab from './General/TransportTab';
// import CargoDtlsTab from './General/CargoDtlsTab';
// import EstimatesTab from './General/EstimatesTab';

const GeneralJobsAdd = ({ accessedModules, accessedPermission }) => {
const [currentData, setCurrentData] = useState([]);
const [pageCount, setPageCount] = useState(0);
const [dataOffset, setDataOffset] = useState(0);
const dataPerPage = 10;

const [reload, setReload] = useState(false);
const [spinnerLoader, setSpinnerLoader] = useState(false)
const [DesignationName, setDesignationName] = useState(null)
const [DesignationId, setDesignationId] = useState(null)
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10; // Number of items per page
const dispatch = useDispatch();

const [agentDisable, setAgentDisable] = useState(true);

const customerOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
]
const joborderOptions = [
{ value: 1, label: "Job order 1" },
{ value: 2, label: "Job order 2" },
{ value: 3, label: "Job order 3" },
{ value: 4, label: "Job order 4" },
{ value: 5, label: "Job order 5" },
]
const quotationOptions = [
{ value: 1, label: "Quotation 1" },
{ value: 2, label: "Quotation 2" },
{ value: 3, label: "Quotation 3" },
{ value: 4, label: "Quotation 4" },
{ value: 5, label: "Quotation 5" },
]
const agentOptions = [
{ value: 1, label: "Agent 1" },
{ value: 2, label: "Agent 2" },
{ value: 3, label: "Agent 3" },
{ value: 4, label: "Agent 4" },
{ value: 5, label: "Agent 5" },
]

const salesPersonOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
]

const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = []

const totalPages = 1;

// Function to change page
const paginate = (pageNumber) => setCurrentPage(pageNumber);

// Function for "Next" and "Previous" buttons
const handleNext = () => {
if (currentPage < totalPages) { setCurrentPage(currentPage + 1); } }; const handlePrevious=()=> {
    if (currentPage > 1) {
    setCurrentPage(currentPage - 1);
    }
    };
    const arr = new Array(5).fill(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
    }
    // const columns = [
    // { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
    // { title: "Date", dataIndex: "date", key: "date" },
    // { title: "Name", dataIndex: "name", key: "name" },
    // { title: "Email", dataIndex: "email", key: "email" },
    // { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
    // { title: "Origin", dataIndex: "origin", key: "origin" },
    // { title: "Destination", dataIndex: "destination", key: "destination" },
    // { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
    // { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
    // { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
    // { title: "Action", dataIndex: "action", key: "action" },
    // ];
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    const columns = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Name", dataIndex: "Name", key: "Name" },
    { title: "Code", dataIndex: "Code", key: "Code" },
    { title: "Prefix", dataIndex: "Prefix", key: "Prefix" },
    { title: "CheckDigit", dataIndex: "CheckDigit", key: "CheckDigit" },
    { title: "Account No", dataIndex: "AccountNo", key: "AccountNo" },
    { title: "Home Page URL", dataIndex: "HomePageURL", key: "HomePageURL" },
    { title: "Tracking URL", dataIndex: "TrackingURL", key: "TrackingURL" },
    { title: "Status", dataIndex: "Status", key: "Status" },
    { title: "Action", dataIndex: "action", key: "action" },
    ];

    const dataSource = [{
    key: "1", // Add a unique key for each row
    SNo: "1", // Changed to camelCase
    Name: "Commission", // Ensure date formatting as neede
    Code: "ChargeCategory",
    Prefix: "Applicable",
    CheckDigit: "Charge",
    AccountNo: "AE",
    HomePageURL: "xyz",
    TrackingURL: "xyz",
    Status:
    <>
        <span className={`cursor-pointer badge badge-pill badge-status bg-success `}>Active</span>

        {/* <div className="form-check form-switch d-flex justify-content-center">
            <div type="button" data-bs-toggle="tooltip" data-bs-placement="bottom" title={value.status===true ? "active"
                : "inactive" }>
                <input className="form-check-input" type="checkbox" id={`flexSwitchCheckChecked-${i}`}
                    checked={value.status===true} onChange={()=> handleChange(value.id)}
                />
            </div>
        </div> */}
    </>
    ,
    action: (
    <div className="dropdown table-action">
        <Link to="#" className="action-icon" data-bs-toggle="dropdown">
        <i className="fa fa-ellipsis-v"></i>
        </Link>
        <div className="dropdown-menu dropdown-menu-right">
            <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
                <i className="ti ti-edit text-blue me-2"></i> Edit
            </div>

        </div>
    </div>
    )
    },
    {
    key: "1", // Add a unique key for each row
    SNo: "1", // Changed to camelCase
    Name: "Commission", // Ensure date formatting as neede
    Code: "ChargeCategory",
    Prefix: "Applicable",
    CheckDigit: "Charge",
    AccountNo: "AE",
    HomePageURL: "xyz",
    TrackingURL: "xyz",
    Status:
    <>
        <span className={`cursor-pointer badge badge-pill badge-status bg-danger `}>Inactive</span>

        {/* <div className="form-check form-switch d-flex justify-content-center">
            <div type="button" data-bs-toggle="tooltip" data-bs-placement="bottom" title={value.status===true ? "active"
                : "inactive" }>
                <input className="form-check-input" type="checkbox" id={`flexSwitchCheckChecked-${i}`}
                    checked={value.status===true} onChange={()=> handleChange(value.id)}
                />
            </div>
        </div> */}
    </>
    ,
    action: (
    <div className="dropdown table-action">
        <Link to="#" className="action-icon" data-bs-toggle="dropdown">
        <i className="fa fa-ellipsis-v"></i>
        </Link>
        <div className="dropdown-menu dropdown-menu-right">
            <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
                <i className="ti ti-edit text-blue me-2"></i> Edit
            </div>

        </div>
    </div>
    )
    }];

    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);

    //select style
    const customControlStyles = base => ({
    height: 20,
    minHeight: 20
    });

    return (
    <>
        <div className="page-wrapper">
            <div className="content">
                <form>
                    <div className="card">

                        <div className="card-body">

                            {/* Filter */}


                            {/* /Filter */}
                            {/* Contact List */}

                            <div className="row-gap-2 pt-5">
    <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">
        {/* Charges Tab */}
        <li className="nav-item" role="presentation">
            <button className="nav-link active" id="charges-tab" data-bs-toggle="pill"
                data-bs-target="#charges" type="button" role="tab" aria-controls="charges"
                aria-selected="true">General Jobs</button>
        </li>

        {/* Disabled Tabs */}
        <li className="nav-item" role="presentation">
            <button className="nav-link disabled" id="Entity-tab" type="button" role="tab"
                aria-controls="Entity" aria-selected="false" disabled>Charges</button>
        </li>
        <li className="nav-item" role="presentation">
            <button className="nav-link disabled" id="ShippingDtls-tab" type="button" role="tab"
                aria-controls="ShippingDtls" aria-selected="false" disabled>Financial</button>
        </li>
        <li className="nav-item" role="presentation">
            <button className="nav-link disabled" id="Reg-tab" type="button" role="tab"
                aria-controls="Reg" aria-selected="false" disabled>Notes</button>
        </li>
        <li className="nav-item" role="presentation">
            <button className="nav-link disabled" id="Reg-tab" type="button" role="tab"
                aria-controls="Reg" aria-selected="false" disabled>History</button>
        </li>
        {/* <li className="nav-item" role="presentation">
            <button className="nav-link disabled" id="transport-tab" type="button" role="tab"
                aria-controls="transport-tab-pane" aria-selected="false" disabled>Container</button>
        </li>
        <li className="nav-item" role="presentation">
            <button className="nav-link disabled" id="customs-tab" type="button" role="tab"
                aria-controls="customs-tab-pane" aria-selected="false" disabled>Attached House</button>
        </li>
        <li className="nav-item" role="presentation">
            <button className="nav-link disabled" id="Customss-tab" type="button" role="tab"
                aria-controls="Customss-tab-pane" aria-selected="false" disabled>Goods Details</button>
        </li>
        <li className="nav-item" role="presentation">
            <button className="nav-link disabled" id="estimates-tab" type="button" role="tab"
                aria-controls="estimates-tab-pane" aria-selected="false" disabled>Pickup</button>
        </li>
        <li className="nav-item" role="presentation">
            <button className="nav-link disabled" id="financialstab-tab" type="button" role="tab"
                aria-controls="financialstab" aria-selected="false" disabled>Financials</button>
        </li>
        <li className="nav-item" role="presentation">
            <button className="nav-link disabled" id="edocket-tab" type="button" role="tab"
                aria-controls="edocket-tab-pane" aria-selected="false" disabled>E-Docket</button>
        </li>
        <li className="nav-item" role="presentation" title="Activity">
            <button className="nav-link disabled" id="activity-tab" type="button" role="tab"
                aria-controls="activity-tab-pane" aria-selected="false" disabled>
                <i className="fa fa-tasks me-1"></i>
            </button>
        </li>
        <li className="nav-item" role="presentation" title="Notes">
            <button className="nav-link disabled" id="notes-tab" type="button" role="tab"
                aria-controls="notes-tab-pane" aria-selected="false" disabled>
                <i className="fa fa-sticky-note me-1"></i>
            </button>
        </li>
        <li className="nav-item" role="presentation" title="History">
            <button className="nav-link disabled" id="history-tab" type="button" role="tab"
                aria-controls="history-tab-pane" aria-selected="false" disabled>
                <i className="fa fa-history me-1"></i>
            </button>
        </li> */}
    </ul>

    <div className="tab-content" id="pills-tabContent">
        {/* Charges Tab Content */}
        <div className="tab-pane fade show active" id="charges" role="tabpanel"
            aria-labelledby="charges-tab">
            <EntityTab />
        </div>

        {/* Other Tab Content */}
        {/* <div className="tab-pane fade" id="Entity" role="tabpanel" aria-labelledby="Entity-tab">
            <EntityTab />
        </div> */}
        {/* <div className="tab-pane fade" id="ShippingDtls" role="tabpanel" aria-labelledby="ShippingDtls-tab">
            <ShippingDtlsTab />
        </div>
        <div className="tab-pane fade" id="Reg" role="tabpanel" aria-labelledby="Reg-tab">
            <RoutingTab />
        </div>
        <div className="tab-pane fade" id="transport-tab-pane" role="tabpanel"
            aria-labelledby="transport-tab" tabIndex="0">
            <ContainerTab />
        </div>
        <div className="tab-pane fade" id="customs-tab-pane" role="tabpanel"
            aria-labelledby="customs-tab" tabIndex="0">
            <AttachedHouseTab />
        </div>
        <div className="tab-pane fade" id="Customss-tab-pane" role="tabpanel"
            aria-labelledby="Customss-tab" tabIndex="0">
            <GoodsDetailsTab />
        </div>
        <div className="tab-pane fade" id="estimates-tab-pane" role="tabpanel"
            aria-labelledby="estimates-tab" tabIndex="0">
            <PickupTab />
        </div>
        <div className="tab-pane fade" id="financialstab" role="tabpanel"
            aria-labelledby="financialstab-tab" tabIndex="0">
            <FinancialsTab />
        </div>
        <div className="tab-pane fade" id="edocket-tab-pane" role="tabpanel"
            aria-labelledby="edocket-tab-pane" tabIndex="0">
            <EdocketTab />
        </div>
        <div className="tab-pane fade" id="activity-tab-pane" role="tabpanel"
            aria-labelledby="activity-tab" tabIndex="0">
            <ActivityTab />
        </div>
        <div className="tab-pane fade" id="notes-tab-pane" role="tabpanel"
            aria-labelledby="notes-tab" tabIndex="0">
            <NotesTab />
        </div>
        <div className="tab-pane fade" id="history-tab-pane" role="tabpanel"
            aria-labelledby="history-tab" tabIndex="0">
            <HistoryTab />
        </div> */}
    </div>
</div>


                        </div>
                    </div>
                </form>
            </div>
        </div>

    </>

    )
    }

    export default GeneralJobsAdd